export const EMPLOYEE_SALARY_PAGE = {
  SALARY: "salary",
  BONUS: "bonus",
  INCOME_DEDUCTION: "income_deduction",
  OVERTIME: "overtime",
  ABSENCE_DEDUCT: "absence_deduct",
  LATE_EARLY_DEDUCT: "late_early_deduct",
  ACCUMULATE: "accumulate",
  LIABILITIES: "liabilities",
  ALLOWANCE: "allowance",
  TAX: "tax",
  SOCIAL_SECURITY: "social_security",
};

export const EMPLOYEE_SALARY_PAGE_LIST = Object.values(EMPLOYEE_SALARY_PAGE);
